import React, {FC, PropsWithChildren} from 'react';
import style from './style.module.scss';
import classNames from 'classnames';
import {TPropsWithClassName} from 'core/types';
import {Chips} from 'components/Chips';

interface IProps {
    onFilterClick?: (filterValue: string) => void;
    filterValue?: string;
    isActive?: boolean;
    isCardView?: boolean;
    dataAutotestTarget?: string;
    dataAutotestTargetId?: string;
    dataActionFilter?: string;
}

export const AddressFilterItem: FC<PropsWithChildren<TPropsWithClassName<IProps>>> = ({
    children,
    onFilterClick,
    filterValue,
    isCardView = true,
    isActive = false,
    dataAutotestTarget,
    dataAutotestTargetId,
    dataActionFilter,
    className,
}) => {
    return (
        <div
            className={classNames(style.container, className, 'address-filter-item')}
            data-action-filter={dataActionFilter}
            data-autotest-target={dataAutotestTarget}
            data-autotest-target-id={dataAutotestTargetId}
            onClick={() => onFilterClick?.(filterValue!)}
        >
            <Chips
                className={classNames(style.item, {
                    [style.cardView]: isCardView,
                    [style.filterView]: !isCardView,
                    [style.active]: isActive,
                    [style.activeImage]: isActive && 'string' !== typeof children,
                })}
                element={'div'}
            >
                {children}
            </Chips>
        </div>
    );
};
